exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control[data-v-c56416f4]{border-radius:10px}", ""]);

// exports
